<template>
<div>

    <header id="header">
        <ul class="header-inner">
            
            <!-- <li id="menu-trigger" data-trigger="#sidebar"> 
                <div class="line-wrap">
                    <div class="line top"></div>
                    <div class="line center"></div>
                    <div class="line bottom"></div>
                </div>
            </li> -->
            <li class="logo">
                <a href="index.html">Tendiendo Puentes</a>
            </li>
            
            <li class="pull-right">
                <ul class="top-menu">
                    <li>
                        <a href="index.html" class="m-t-3">Volver</a>
                    </li>
                </ul>
            </li>
        </ul>
    </header>

    <div class="row div-0 margin-for-header">

        <div v-if="showAside" class="col-md-3 col-sm-3 hidden-xs div-0">

            <div v-if="currentComercio" class="card card-100">
                <comercio-view></comercio-view>
            </div>
            
            <div v-else class="card card-100 animated fadeIn">
                <div class="card-header ch-alt">
                    <h2>Búsqueda de Comercios<small>{{ listCount }} comercios encontrados.</small></h2>
                </div>

                <div class="card-body card-padding">
                    <form role="form">
                        <div class="form-group fg-line">
                            <label>Nombre:</label>
                            <input type="text" v-model="query.filter.byNombre" class="form-control input-sm" placeholder="Nombre del comercio...">
                        </div>

                        <div v-if="optionsTiposComercios.length>0" class="form-group fg-line">
                            <label>Tipo de comercio:</label>
                            <div class="select">
                                <select @keydown="selectKeyHandler" v-model="query.filter.byTiposComercios" class="form-control tag-select">
                                    <option value="" selected>[Todos]</option>
                                    <option v-for="item of optionsTiposComercios" :value="item.id" :key="item.id">{{ item.nombre }}</option>
                                </select>
                            </div> 
                        </div>

                        <div class="form-group fg-line">
                            <label>Formas de entrega:</label>
                            <div class="select">
                                <select @keydown="selectKeyHandler" v-model="query.filter.byTiposFormasEntrega" class="form-control tag-select">
                                    <option value="" selected>[Todas]</option>
                                    <option value="delivery">Servicios de delivery</option>
                                    <option value="takeaway">Retiro de Local</option>
                                </select>
                            </div> 
                        </div>

                        <div v-if="optionsZonasEntrega.length>0" class="form-group fg-line">
                            <label>Zonas de Entrega:</label>
                            <div class="select">
                                <select @keydown="selectKeyHandler" v-model="query.filter.byZonasEntrega" class="form-control tag-select">
                                    <option value="" selected>[Todos]</option>
                                    <option v-for="item of optionsZonasEntrega" :value="item.id" :key="item.id">{{ item.nombre }}</option>
                                </select>
                            </div> 
                        </div>

                        <div v-if="optionsTiposMediosPago.length>0" class="form-group fg-line">
                            <label>Medios de pago:</label>
                            <div class="select">
                                <select @keydown="selectKeyHandler" v-model="query.filter.byTiposMediosPago" class="form-control tag-select">
                                    <option value="" selected>[Todos]</option>
                                    <option v-for="item of optionsTiposMediosPago" :value="item.id" :key="item.id">{{ item.nombre }}</option>
                                </select>
                            </div> 
                        </div>

                        <button @click.prevent="aplicarFiltros()" type="submit" class="btn btn-primary btn-block m-t-10"><i class="zmdi zmdi-search m-r-5"></i> Aplicar Filtros</button>
                        <button @click.prevent="limpiarFiltros()" type="submit" class="btn btn-default btn-block m-t-10"><i class="zmdi zmdi-undo m-r-5"></i> Limpiar Búsqueda</button>
                    </form>
                </div>
            </div>
        </div>

        <div :class="showAside ? 'col-md-9' : 'col-md-12'" class="col-sm-9 col-xs-12 div-0">
            <div id="map" ref="map" class="div-0"></div>
        </div>
    </div>

</div>
</template>

<script>
import { HTTPAPI, showResponseErrorMessage } from '../../share.js';
import { mapState } from 'vuex';
import axios from 'axios';
import {Jumper} from 'vue-loading-spinner';
import MarkerClusterer from '@googlemaps/markerclustererplus';

import comercioView from './comercio.view.vue';

export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            listItems: [],
            listCount: 0,
            isLoading: true,
            query: {
                order: '',
                page: 0,
                limit: 25,
                filter: {
                    byNombre : '',
                    byTiposComercios : '',
                    byTiposMediosPago : '',
                    byZonasEntrega : '',
                    byTiposFormasEntrega : ''
                }
            },
            optionsTiposComercios: [],
            optionsTiposMediosPago: [],
            optionsZonasEntrega: [],
            filtersTags: [],
            googleMaps: {
                map: null,
                options: {
                    zoom: 7,
                    mapTypeId: 'roadmap',
                    center: {
                        lat: -32.2812563, 
                        lng: -63.3518803
                    }
                },
                markers: [],
                markerCluster: null
            },
            showAside: true,
            showComercioDetail: false
        }
    },
    computed: {
        ...mapState(['comercios','currentComercio'])
    },
    components: {
        comercioView,
        Jumper
    },
    mounted() {
        this.googleMaps.map = new window.google.maps.Map(this.$refs.map, this.googleMaps.options);
        this.getData();
    },
    methods: {
        getData() {
            let self = this;
            
            axios.all([self.getTiposComercios(), self.getTiposMediosPago(), self.getZonasEntrega()])
            .then(axios.spread(function (responseTiposComercios, responseTiposMediosPago, responseZonasEntrega) {
                self.optionsTiposComercios = responseTiposComercios.data;
                self.optionsTiposMediosPago = responseTiposMediosPago.data;
                self.optionsZonasEntrega = responseZonasEntrega.data;
            }))
            .then(() => {
                self.getComercios()
                // self.listItems = self.comercios;
                // self.listCount = self.listItems.length;
                // this.setGoogleMapsMarkers();
            });
        },
        getTiposComercios() {
            return HTTPAPI.get('tiposComerciosPublicados?order=nombre');
        },
        getTiposMediosPago() {
            return HTTPAPI.get('tiposMediosPagoPublicados?estado=1&order=nombre');
        },
        getZonasEntrega() {
            return HTTPAPI.get('zonasEntregaPublicados?order=nombre');
        },
        getComercios(){
            let self = this;

            this.isLoading = true;

            this.listItems = [];
            self.listCount = 0;
            this.clearGoogleMapsMarkers();

            let query = '?id_estado=3';
            query += (self.query.order != "") ? '&order=' + self.query.order : '';
            query += (self.query.filter.byNombre != "") ? '&nombre=' + self.query.filter.byNombre : '';
            query += (self.query.filter.byTiposComercios != "") ? '&id_tipo_comercio=' + self.query.filter.byTiposComercios : '';
            query += (self.query.filter.byTiposMediosPago != "") ? '&id_tipo_medio_pago=' + self.query.filter.byTiposMediosPago : '';
            query += (self.query.filter.byZonasEntrega != "") ? '&id_zona_entrega=' + self.query.filter.byZonasEntrega : '';

            if (self.query.filter.byTiposFormasEntrega == 'delivery') {
                query += '&delivery=1';
            } else if (self.query.filter.byTiposFormasEntrega == 'takeaway') {
                query += '&takeaway=1';
            }

            HTTPAPI.get('/comercios' + query)
            .then(response => {
                if (response.status === 200) {
                    self.listCount = response.headers['x-total-count'] || response.headers['X-Total-Count'] || 0;
                    if (response.data.length > 0) {
                        self.listItems = response.data;
                        self.listCount = self.listItems.length;
                        this.setGoogleMapsMarkers();
                    }
                }
            }).catch(error => {
                console.log('error',error);
                // showResponseErrorMessage({ status : error.response.status });
            }).finally(() => { 
                this.isLoading = false;
            }); 
        },
        aplicarFiltros() {
            this.getComercios();
        },
        limpiarFiltros() {
            this.listItems = [];
            this.query.filter.byNombre = '';
            this.query.filter.byTiposComercios = "";
            this.query.filter.byTiposMediosPago = "";
            this.query.filter.byZonasEntrega = "";
            this.query.filter.byTiposFormasEntrega = "";

            this.getComercios();
        },
        clearGoogleMapsMarkers(){
            this.googleMaps.markers.forEach(marker => {
                marker.setMap(null);
            });

            this.googleMaps.markers = [];
            
            if (this.markerCluster) {
                //Limpio los clusters
                this.markerCluster.clearMarkers();
            }
        },
        setGoogleMapsMarkers(){
            let self = this;

            let toastMessage = 'Aguarde mientras preparamos el mapa...';
            this.$toasted.global.success_toast({message : toastMessage});
            
            this.clearGoogleMapsMarkers();

            let comercios = this.listItems;
            var markers = comercios.map(function(comercio, i) {
                // Preparo el marker
                let location = {
                    title : comercio.nombre,
                    position : {
                        lat:  parseFloat(comercio.latitud), 
                        lng:  parseFloat(comercio.longitud)
                    }
                };

                // Agrego el marker al mapa
                let markerIcon = `${self.publicPath}img/googlemaps-point-tendiendopuentes-min.png`;
                let marker = new google.maps.Marker({
                    id: comercio.id,
                    map: self.googleMaps.map,
                    position: location.position,
                    animation: google.maps.Animation.DROP,
                    icon: markerIcon
                });

                //InfoWindows
                let contentString = self.getInfoWindows(comercio);
                let infoWindow = new google.maps.InfoWindow({
                    content: contentString
                });

                // Agrego evento mouseover al marker
                marker.addListener('mouseover', function() { 
                        infoWindow.open(self.googleMaps.map, marker);
                });
                
                marker.addListener('mouseout', function() { 
                        infoWindow.close();
                });

                // Agrego evento click al marker
                marker.addListener('click', function() {
                    let id = marker.get('id');
                    self.getComercioDetail(id);
                });

                // Agrego el marquer al array
                self.googleMaps.markers.push(marker);

                return marker;
            });

            let clusterStyles = [
                {
                    width: 30,
                    height: 30,
                    className: "custom-clustericon-1",
                },
                {
                    width: 40,
                    height: 40,
                    className: "custom-clustericon-2",
                },
                {
                    width: 50,
                    height: 50,
                    className: "custom-clustericon-3",
                },
                {
                    width: 50,
                    height: 50,
                    className: "custom-clustericon-4",
                },
                {
                    width: 50,
                    height: 50,
                    className: "custom-clustericon-5",
                },
            ]

            self.markerCluster = new MarkerClusterer(self.googleMaps.map, markers, {
                maxZoom: 15,
                gridSize: 30,
                styles: clusterStyles,
                clusterClass: "custom-clustericon",
            });

            this.isLoading = false;

        },
        getComercioDetail(id) {
            this.$store.dispatch('getCurrentComercio', id);
        },
        getInfoWindows(comercio) {
            let strDomicilio = `${comercio.domicilio_calle} ${comercio.domicilio_numero} ${comercio.domicilio_piso}`;
            
            let strTipos = '';
            if (comercio.tipos_comercios) {
                strTipos = comercio.tipos_comercios.reduce( function (accumulator, item) {
                        return `${accumulator} ${item.nombre}, `;
                    }, '' );
                strTipos = strTipos.slice(0, -2);
            }

            let contentString = `<div style="min-width: 150px; max-width: 250px; padding:20px; text-align: center">
                <h2 style="margin:0px 0px 10px 0px; padding-bottom: 10px; line-height: 100%; font-size:17px; font-weight:400; color:#a4343a; border-bottom: 1px solid #e6e6e6;">${comercio.nombre}</h2>
                <div style="font-size:11px; margin-bottom:5px">${strTipos}</div>
                <div style="font-size:11px;">${strDomicilio}</div>
                </div>`;
            
            return contentString;
        },
        selectKeyHandler(e){
            if(e.key === 'Enter'){
                e.preventDefault()
                this.aplicarFiltros();
            }
        }
    }
}
</script>

<style lang="scss" scoped>

html, body {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
}

.div-0 {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
}

#map {
    height: calc(100vh - 65px) !important;
    width: 100%;
}

.card-100 {
    margin: 0;
    padding: 0;
    border: 0;

    overflow-y: auto;
    height: calc(100vh - 65px) !important;
    max-height: calc(100vh - 65px) !important;
    width: 100%;
}


.margin-for-header {
    margin-top: 65px;
}


#particles-js{
        position: absolute;
        height: 100vh !important;
        width: 100%;
        background-color: #eb3349;
        background-image: -webkit-linear-gradient(45deg, #eb3349, #f45c43);
        background-image: linear-gradient(45deg, #eb3349, #f45c43);
        color: #fff;
        font-size: 1em;
        text-align: center;
    }

</style>